import { render } from "./Loader.vue?vue&type=template&id=6d1458c8&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=6d1458c8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1458c8"]])

export default __exports__